import React from 'react';

interface FieldGroupProps {
  label: string;
  children: React.ReactNode;
  /** Akzent-Farbe für Hintergrund/Rahmen (default: neutraler Surface-Ton) */
  tone?: 'default' | 'accent' | 'success' | 'warn' | 'expose';
  /** Hinweistext klein unter dem Label */
  hint?: string;
  /** Inline-Style override */
  style?: React.CSSProperties;
}

const TONE_MAP = {
  default: { bg: 'var(--surface)',      border: 'var(--border2)', label: 'var(--text3)' },
  accent:  { bg: 'var(--accent-light)', border: 'var(--accent-mid)', label: 'var(--accent)' },
  success: { bg: 'var(--success-bg)',   border: '#b2dfcc',         label: 'var(--success)' },
  warn:    { bg: 'var(--warn-bg)',      border: '#e0c87c',         label: 'var(--warn)' },
  expose:  { bg: '#f7f7f5',             border: '#d8d4cc',         label: '#7a7466' },
};

/**
 * Visuelle Klammer für inhaltlich zusammengehörige Felder
 * (z.B. Volumen min/max, Einheiten min/max, WALT min/max).
 * Konzept §4.2/4.3.
 */
export function FieldGroup({ label, children, tone = 'default', hint, style }: FieldGroupProps) {
  const t = TONE_MAP[tone];
  return (
    <div style={{
      border: `1px solid ${t.border}`,
      borderRadius: 'var(--radius-lg)',
      padding: '10px 12px 12px',
      background: t.bg,
      ...style,
    }}>
      <div style={{
        fontSize: '10px', fontWeight: 600,
        textTransform: 'uppercase', letterSpacing: '0.7px',
        color: t.label, marginBottom: '8px',
      }}>
        {label}
        {hint && <span style={{ fontWeight: 400, marginLeft: 8, color: 'var(--text3)', textTransform: 'none', letterSpacing: 0 }}>· {hint}</span>}
      </div>
      {children}
    </div>
  );
}
